<hr />
@if (groupForm) {
  @if ((hasWritePermission$ | async) === false || isFloorplanItemLocked || floorplan.project.groups.length <= 0) {
    <form odxForm [formGroup]="groupForm" [readonly]="true">
      <odx-form-field i18n-label="@@floorplan.details.form.group.select.label" label="Gruppe">
        <odx-select
          [clearable]="false"
          i18n-placeholder="@@floorplan.details.form.group.select.placeholder"
          placeholder="Keine Gruppe"
          odxFormFieldControl
          formControlName="group"
        >
          @for (group of this.floorplan.project.groups; track group) {
            <odx-select-option [value]="group.id">
              {{ group.name }}
            </odx-select-option>
          }
        </odx-select>
      </odx-form-field>
    </form>
  } @else {
    <form odxForm [formGroup]="groupForm">
      <odx-form-field i18n-label="@@floorplan.details.form.group.select.label" label="Gruppe">
        <odx-select
          [clearable]="true"
          i18n-placeholder="@@floorplan.details.form.group.select.placeholder"
          placeholder="Keine Gruppe"
          odxFormFieldControl
          formControlName="group"
        >
          @for (group of this.floorplan.project.groups; track group) {
            <odx-select-option [value]="group.id">
              {{ group.name }}
            </odx-select-option>
          }
        </odx-select>
      </odx-form-field>
    </form>
  }
}

@if (this.currentGroup) {
  <div>
    <app-toggle-group-visibility-button
      [group]="this.currentGroup"
      [isSelected]="this.checkIsGroupSelected()"
    ></app-toggle-group-visibility-button>
    @if ((isReadOnlyUser$ | async) === false) {
      <div class="odx-margin-bottom-8 odx-margin-top-8">
        <a
          [disabled]="(hasWritePermission$ | async) === false || isFloorplanItemLocked"
          odxLink
          href="#"
          i18n="@@floorplan.details.form.group.editGroup"
          (click)="editGroup(); $event.preventDefault()"
        >
          <odx-icon name="edit" size="medium"></odx-icon>
          Gruppe bearbeiten
        </a>
      </div>
    }
  </div>
}

@if ((isReadOnlyUser$ | async) === false) {
  <div>
    <a
      [disabled]="(hasWritePermission$ | async) === false || isFloorplanItemLocked"
      odxLink
      href="#"
      i18n="@@floorplan.details.form.group.btnAdd"
      (click)="createGroup(); $event.preventDefault()"
    >
      <odx-icon name="plus" size="medium"></odx-icon>
      Neue Gruppe erstellen
    </a>
  </div>
}

<hr />
